(function () {
  let currentVariant = new URLSearchParams(window.location.search).get('variant');

  function dispatchVariantChange(variantId) {
    document.dispatchEvent(
      new CustomEvent('shopify:variant:change', {
        detail: {
          variantId
        }
      })
    );
  }

  // Dispatch on initial load
  if (currentVariant) {
    dispatchVariantChange(currentVariant);
  }

  // Listen for history popstate (e.g. browser back/forward)
  window.addEventListener('popstate', function () {
    const newVariant = new URLSearchParams(window.location.search).get('variant');
    if (newVariant && newVariant !== currentVariant) {
      currentVariant = newVariant;
      dispatchVariantChange(currentVariant);
    }
  });

  document.querySelectorAll('.variant-radios').forEach((selector) => {
    selector.addEventListener('change', function (e) {

      setTimeout(() => {

        const urlParams = new URLSearchParams(window.location.search);
        const newVariant = urlParams.get('variant');

        if (newVariant && newVariant !== currentVariant) {
          currentVariant = newVariant;
          dispatchVariantChange(currentVariant);
        }
      }, 500)
    });
  })

})();

class AccountWishListItemRemove extends HTMLElement {
  constructor() {
    super();

    const _id = this.getAttribute('data-v');
    const _customer = this.getAttribute('data-c');
    const _email = this.getAttribute('data-e');
    const _store = this.getAttribute('data-s');
    const _product = this.getAttribute('data-p');
    const _handle = this.getAttribute('data-h');

    this.addEventListener('click', (e) => {
      this.removeItemFromWishlist(_id, _customer, _email, _store, _product, _handle);
    })
  }


  async removeItemFromWishlist(id, customer, email, store, product, handle) {
    try {

      const host = window?.Shopify?.shop;

      const r = await fetch(`https://www.vapesuperstore.co.uk/tools/wishlist`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id,
          customer,
          email,
          kind: "remove",
          store,
          wishlist: {
            product,
            handle
          }
        })
      });

      if (!r.ok) {
        throw new Error(`Request failed with status ${r.status}`);
      }

      const content = await r.json();

      if (content?.kind == 'remove') {
        const t = content?.target;
        document.querySelector(`.ecs-wishlist__item[data-id="${t}"]`).remove();
      }

    } catch (error) {
      console.error('Failed to remove item from wishlist:', error);
    }
  }
}

customElements.define("ecs-wishlist-item-remove", AccountWishListItemRemove);


class ProductWishList extends HTMLElement {
  constructor() {
    super();

    const _id = this.getAttribute('data-v');
    const _customer = this.getAttribute('data-c');
    const _email = this.getAttribute('data-e');
    const _store = this.getAttribute('data-s');
    const _product = this.getAttribute('data-p');
    const _handle = this.getAttribute('data-h');

    document.addEventListener('shopify:variant:change', ({
      detail
    }) => {
      this.setAttribute('data-v', detail.variantId);
    });

    this.addEventListener('click', (e) => {
      this.addToWishlist(_id, _customer, _email, _store, _product, _handle);
    })
  }

  async addToWishlist(id, customer, email, store, product, handle) {
    try {


      const host = window?.Shopify?.shop;

      const r = await fetch(`https://www.vapesuperstore.co.uk/tools/wishlist?redirect=${this.getAttribute('data-should-redirect')}`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id,
          customer,
          email,
          kind: "add",
          store,
          wishlist: {
            product,
            handle
          }
        })
      });

      if (!r.ok) {
        throw new Error(`Request failed with status ${r.status}`);
      }

      const content = await r.json();

      if (content?.kind == 'add') {

        if (content?.redirect) {
          window.location = `/tools/wishlist`;
        } else {
          const t = content?.target;
          document.querySelector(`.ecs-wishlist-pdp__add-button[data-v="${t}"]`).remove();
        }

      }



    } catch (error) {
      console.error('Failed to add item to wishlist:', error);
    }
  }



  async removeFromWishlist(id) {


  }

}

customElements.define("ecs-product-wishlist", ProductWishList);


class WishlistController extends HTMLElement {
  constructor() {
    super();

    const _default_id = this.getAttribute('data-default-v');
    const _customer = this.getAttribute('data-c');
    const _email = this.getAttribute('data-e');
    const _store = this.getAttribute('data-s');
    const _product = this.getAttribute('data-p');
    const _handle = this.getAttribute('data-h');

    document.addEventListener('shopify:variant:change', ({
      detail
    }) => {

      if (this.getAttribute('data-loading') !== 'true') {
        this.setAttribute('data-loading', 'true');
      }

      const activeItems = this.getAttribute('data-items');
      const currentVariant = detail.variantId;

      if (activeItems) {
        const activeArray = activeItems.split(',');

        if (activeArray.includes(currentVariant)) {
          this.setAttribute('data-kind', 'remove');
          this.setAttribute('data-loading', 'false');
        } else {
          this.setAttribute('data-kind', 'add');
          this.setAttribute('data-loading', 'false');
        }
      }

      this.setAttribute('data-v', currentVariant);

    });

    this.addEventListener('click', (e) => {

      if (this.getAttribute("data-kind") === "add") {

        this.addToWishlist(this.getAttribute('data-v') || this.getAttribute('data-default-v'), _customer, _email, _store, _product, _handle)

      } else if (this.getAttribute("data-kind") === "remove") {

        this.removeItemFromWishlist(this.getAttribute('data-v') || this.getAttribute('data-default-v'), _customer, _email, _store, _product, _handle)

      }

    })


  }


  static get observedAttributes() {
    return ['data-items', 'data-kind', 'data-loading'];
  }

  connectedCallback() {
    const _customer = this.getAttribute('data-c');
    const _defaultId = this.getAttribute('data-default-v');

    this.getWishlist(_customer)
      .then(content => {

        if (content?.customerList != null) {
          const vValues = content.customerList.map(item => item.v);
          const vList = vValues.join(',');

          this.setAttribute('data-items', vList);

          if (_defaultId && vValues.includes(_defaultId)) {
            this.setAttribute('data-kind', 'remove');
          } else {
            this.setAttribute('data-kind', 'add');
          }
        } else {
          this.setAttribute('data-items', "none");
          this.setAttribute('data-kind', 'add');
        }
      })
      .catch((error) => {
        console.error('Error fetching wishlist:', error);
        this.setAttribute('data-kind', 'add');
      })
      .finally(() => {
        this.setAttribute('data-loading', 'false');
      });
  }


  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-kind' || name === 'data-items' || name === 'data-loading') {
      this.render(this.getAttribute('data-kind'));
    }
  }


  render(kind) {

    const isLoading = this.getAttribute('data-loading') === 'true';

    if (isLoading) {
      this.innerHTML = `<div class="ecs-action__loading"><svg width="256" height="256" viewBox="0 0 32 32">
  <rect x="0" y="0" width="32" height="32" rx="8" fill="none" />
  <clipPath id="fill-clip">
    <rect id="clip-rect" x="0" y="32" width="32" height="32">
      <animate
        attributeName="y"
        values="32;0;32"
        dur="2s"
        repeatCount="indefinite"
      />
    </rect>
  </clipPath>
  <path
    d="M3.384 7.13c2.972-4.17 9.167-4.174 12.146-.008l.465.65l.417-.593c2.955-4.195 9.16-4.236 12.17-.081A7.48 7.48 0 0 1 28 16.583L16.732 28.681a1 1 0 0 1-1.464 0L3.992 16.54a7.462 7.462 0 0 1-.608-9.41Zm10.52 1.155c-2.181-3.05-6.716-3.046-8.892.007a5.462 5.462 0 0 0 .446 6.887L16.002 26.53l10.534-11.31a5.48 5.48 0 0 0 .427-6.95c-2.205-3.044-6.751-3.013-8.916.06l-1.229 1.744a1 1 0 0 1-1.63.006l-1.285-1.796Z"
    fill="#ccc"
  />
  <path
    clip-path="url(#fill-clip)"
    fill="#338491"
    d="M3.384 7.13c2.972-4.17 9.167-4.174 12.146-.008l.465.65l.417-.593c2.955-4.195 9.16-4.236 12.17-.081A7.48 7.48 0 0 1 28 16.583L16.732 28.681a1 1 0 0 1-1.464 0L3.992 16.54a7.462 7.462 0 0 1-.608-9.41Zm10.52 1.155c-2.181-3.05-6.716-3.046-8.892.007a5.462 5.462 0 0 0 .446 6.887L16.002 26.53l10.534-11.31a5.48 5.48 0 0 0 .427-6.95c-2.205-3.044-6.751-3.013-8.916.06l-1.229 1.744a1 1 0 0 1-1.63.006l-1.285-1.796Z"
  />
</svg>
</div>
`;
      return;
    }

    if (kind === "add") {
      this.innerHTML = `<div class="ecs-action__add"><span>
      <svg width="256" height="256" viewBox="0 0 32 32"><rect x="0" y="0" width="32" height="32" rx="8" fill="none"/><svg viewBox="0 0 32 32" fill="#338491" x="0" y="0" width="32" height="32"><path fill="#338491" d="M3.384 7.13c2.972-4.17 9.167-4.174 12.146-.008l.465.65l.417-.593c2.955-4.195 9.16-4.236 12.17-.081A7.48 7.48 0 0 1 28 16.583L16.732 28.681a1 1 0 0 1-1.464 0L3.992 16.54a7.462 7.462 0 0 1-.608-9.41Zm10.52 1.155c-2.181-3.05-6.716-3.046-8.892.007a5.462 5.462 0 0 0 .446 6.887L16.002 26.53l10.534-11.31a5.48 5.48 0 0 0 .427-6.95c-2.205-3.044-6.751-3.013-8.916.06l-1.229 1.744a1 1 0 0 1-1.63.006l-1.285-1.796Z"/></svg></svg>
      </span></div>`
      return;
    } else if (kind === "remove") {
      this.innerHTML = `<div class="ecs-action__remove"><span>
  <svg width="256" height="256" viewBox="0 0 32 32"><rect x="0" y="0" width="32" height="32" rx="8" fill="none"/><svg viewBox="0 0 32 32" fill="#338491" x="0" y="0" width="32" height="32"><path fill="#338491" d="M15.53 7.122c-2.979-4.166-9.174-4.162-12.146.009a7.462 7.462 0 0 0 .609 9.409l11.275 12.14a1 1 0 0 0 1.464.001L28 16.583a7.48 7.48 0 0 0 .584-9.485c-3.01-4.155-9.216-4.114-12.171.081l-.417.593l-.465-.65Z"/></svg></svg>
      </span></div>`
      return;
    }

  }

  async getWishlist(customer) {
    try {

      const host = window?.Shopify?.shop;

      const r = await fetch(`https://www.vapesuperstore.co.uk/tools/wishlist/get/${customer}`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          customer
        })
      });

      if (!r.ok) {
        throw new Error(`Request failed with status ${r.status}`);
      }

      const content = await r.json();

      if (content?.kind == 'get') {
        return content;
      }

    } catch (error) {
      console.error('Failed to get wishlist:', error);
    }
  }


  async addToWishlist(id, customer, email, store, product, handle) {
    try {

      let hasCustomerSelectedVaraint = false;
      const urlParams = new URLSearchParams(window.location.search);
      const newVariant = urlParams.get('variant');

      // console.log(newVariant);

      if (newVariant == null) {
        hasCustomerSelectedVaraint = false;
      } else {
        hasCustomerSelectedVaraint = true;
      }

      this.setAttribute('data-loading', 'true');

      const host = window?.Shopify?.shop;

      const r = await fetch(`https://www.vapesuperstore.co.uk/tools/wishlist?redirect=${this.getAttribute('data-should-redirect')}`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id,
          customer,
          email,
          kind: "add",
          store,
          wishlist: {
            product,
            handle
          },
          selected: hasCustomerSelectedVaraint
        })
      });

      if (!r.ok) {
        throw new Error(`Request failed with status ${r.status}`);
      }

      const content = await r.json();


      if (content?.kind == 'add') {

        if (content?.redirect) {
          window.location = `/tools/wishlist`;
        } else {

          const _customer = this.getAttribute('data-c');
          this.getWishlist(_customer).then(content => {
            if (content) {
              const vValues = content.customerList.map(item => item.v);
              const vList = vValues.join(',');
              this.setAttribute('data-loading', 'false');
              this.setAttribute('data-items', vList);
              this.setAttribute('data-kind', 'remove');

            }
          });


        }

        document.querySelectorAll('[data-ecs-dynamic-counter]').forEach((el)=> {
          el.innerHTML = content?.updatedList?.wishlist?.length;
          el.parentElement.classList.remove('visually-hidden');
        })


      }

    } catch (error) {
      this.setAttribute('data-loading', 'false');
      console.error('Failed to add item to wishlist:', error);
    }
  }


  async removeItemFromWishlist(id, customer, email, store, product, handle) {
    try {
      this.setAttribute('data-loading', 'true');

      const host = window?.Shopify?.shop;

      const r = await fetch(`https://www.vapesuperstore.co.uk/tools/wishlist`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id,
          customer,
          email,
          kind: "remove",
          store,
          wishlist: {
            product,
            handle
          }
        })
      });

      if (!r.ok) {
        throw new Error(`Request failed with status ${r.status}`);
      }

      const content = await r.json();

      if (content?.kind == 'remove') {

        const _customer = this.getAttribute('data-c');
        this.getWishlist(_customer).then(content => {
          if (content?.customerList != null) {
            const vValues = content.customerList.map(item => item.v);
            const vList = vValues.join(',');
            this.setAttribute('data-loading', 'false');
            this.setAttribute('data-items', vList);
            this.setAttribute('data-kind', 'add');
          } else {
            this.setAttribute('data-loading', 'false');
            this.setAttribute('data-items', 'none');
            this.setAttribute('data-kind', 'add');
          }
        });

        document.querySelectorAll('[data-ecs-dynamic-counter]').forEach((el)=> {
          if(content?.updatedList?.wishlist?.length == undefined) {
            el.parentElement.classList.add('visually-hidden');
            el.innerHTML = 0;
          } else {
            el.innerHTML = content?.updatedList?.wishlist?.length;
            el.parentElement.classList.remove('visually-hidden');
          }

        })

      }

    } catch (error) {
      this.setAttribute('data-loading', 'false');
      console.error('Failed to remove item from wishlist:', error);
    }
  }


}

customElements.define("ecs-wishlist-controller", WishlistController);




class WishlistPrompt extends HTMLElement {
  constructor() {
    super();
    const _default_id = this.getAttribute('data-default-v');

    this.addEventListener('click', (e) => {
      this.openModal();
    })
  }

  connectedCallback() {
    this.render();
  }

  render() {
      this.innerHTML = `<div class="ecs-action__add"><span>
      <svg width="256" height="256" viewBox="0 0 32 32"><rect x="0" y="0" width="32" height="32" rx="8" fill="none"/><svg viewBox="0 0 32 32" fill="#338491" x="0" y="0" width="32" height="32"><path fill="#338491" d="M3.384 7.13c2.972-4.17 9.167-4.174 12.146-.008l.465.65l.417-.593c2.955-4.195 9.16-4.236 12.17-.081A7.48 7.48 0 0 1 28 16.583L16.732 28.681a1 1 0 0 1-1.464 0L3.992 16.54a7.462 7.462 0 0 1-.608-9.41Zm10.52 1.155c-2.181-3.05-6.716-3.046-8.892.007a5.462 5.462 0 0 0 .446 6.887L16.002 26.53l10.534-11.31a5.48 5.48 0 0 0 .427-6.95c-2.205-3.044-6.751-3.013-8.916.06l-1.229 1.744a1 1 0 0 1-1.63.006l-1.285-1.796Z"/></svg></svg>
      </span></div>`
      return;
  }

  openModal() {
    document.querySelector('.ecs-wishlist-signin-modal').setAttribute('data-status', 'open');
  }

}

customElements.define("ecs-wishlist-prompt", WishlistPrompt);




class WishlistModal extends HTMLElement {
  constructor() {
    super();

    this.querySelector('[data-closer="true"]').addEventListener('click', ()=> {
      this.closeModal();
    })
  }


  closeModal() {
    document.querySelector('.ecs-wishlist-signin-modal').setAttribute('data-status', 'closed');
  }

}

customElements.define("ecs-wishlist-modal", WishlistModal);